<script>
import Axios from 'axios'

export default {
  data: function () {
    return {
    }
  },
  methods: {
    validateHiragana2: function (value) {
      if (value.match(/^[あ-んぁ-ょゔ－―‐－ー～\s　・]*$/)) {
        return true
      }
      else {
        return false
      }
    },
    validatePeriod: function (value) {
      if (value.match(/\./)) {
        return false
      }
      else {
        return true
      }
    }
  }
}
</script>
